import { BoxContainer } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

export function TryOtherShoe(): JSX.Element {
  const { t } = useTranslation();

  return (
    <BoxContainer>
      <span className="font-bold text-xl opacity-50">{t("tryOtherShoe")}</span>
      <span className="font-normal text-base opacity-50 pt-4">{t("tryOtherShoeDescription")}</span>
    </BoxContainer>
  );
}
